import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { AppState } from '../index';

import * as OccupationActions from './occupation.actions';
import * as OccupationSelectors from './occupation.selectors';
import { OccupationProfileModel } from '@cpd-app/core-module/models';

@Injectable({
  providedIn: 'root'
})
export class OccupationFacade {
  public occupationProfile$ = this.store.select(
    OccupationSelectors.getOccupationProfile
  );

  constructor(private store: Store<AppState>) {}

  setOccupationProfile(occupationProfileModel: OccupationProfileModel) {
    this.removeOccupationProfile();

    this.store.dispatch(
      OccupationActions.setOccupationProfile({ occupationProfileModel })
    );
  }

  removeOccupationProfile() {
    this.store.dispatch(OccupationActions.removeOccupationProfile());
  }

  requestOccupationsByDemandList() {
    this.store.dispatch(OccupationActions.requestOccupationsByDemandList());
  }

  requestMilitaryFriendlyOccupationsList() {
    this.store.dispatch(
      OccupationActions.requestMilitaryFriendlyOccupationsList()
    );
  }
}
